import { render, staticRenderFns } from "./carRecognition.vue?vue&type=template&id=143a1dad&scoped=true"
import script from "./carRecognition.vue?vue&type=script&lang=js"
export * from "./carRecognition.vue?vue&type=script&lang=js"
import style0 from "./carRecognition.vue?vue&type=style&index=0&id=143a1dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a1dad",
  null
  
)

export default component.exports